import { render } from "./CxFilterUnitView.vue?vue&type=template&id=28cd0e32"
import script from "./CxFilterUnitView.vue?vue&type=script&lang=js"
export * from "./CxFilterUnitView.vue?vue&type=script&lang=js"

import "./CxFilterUnitView.vue?vue&type=style&index=0&id=28cd0e32&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__